/**
 * Usage:
 *
 * data-sw-shapejs-creator-form=<creatorId>
 *
 */

var $ = require('js/sw-jquery/sw-jquery');

module.exports = function($fragment) {

  $fragment.swFindWithSelf('[data-sw-shapejs-sample-images]').each(function() {
    var $el = $(this);

    require([
      'js/lib/models/ModelManager',
      'js/lib/views/ShapeJS/ShapeJsSampleImagesView'
    ], function(ModelManager, ShapeJsSampleImagesView) {

      var creatorId = $el.data('swShapejsSampleImages');
      var shapeJsModel = ModelManager.getShapeJs(creatorId);

      new ShapeJsSampleImagesView({
        stateId: creatorId,
        el: $el,
        model: shapeJsModel
      });

    });

  });

};
